import { Box, Heading, Text, useBreakpointValue, useColorModeValue } from '@chakra-ui/react';
import { GroupStandingsTable } from '@/components/GroupStandingsTable';
import { type Country } from '@/models/country';
import type { GroupStandingRow } from '@/models/groupStandings';
import { type WorldCupGroupId, groupTitleShort } from '@/models/wc26Groups';

export function GroupCard(props: {
  groupId: WorldCupGroupId;
  teams: Country[];
  standings?: GroupStandingRow[];
}) {
  const cardBg = useColorModeValue('gray.50', 'gray.700');
  const mutedColor = useColorModeValue('gray.600', 'gray.400');
  const showSwipeHint = useBreakpointValue({ base: true, lg: false });

  return (
    <Box bg={cardBg} borderRadius={{ base: 16, lg: 0 }} px={{ base: 3, md: 4 }} py={4} w='full' minW={0} overflow='visible'>
      <Heading fontSize='md' fontWeight='semibold' pb={showSwipeHint ? 1 : 3} textAlign='left'>
        {groupTitleShort(props.groupId)}
      </Heading>
      {showSwipeHint ? (
        <Text fontSize='xs' color={mutedColor} pb={2}>
          Swipe table for full stats
        </Text>
      ) : null}
      <GroupStandingsTable teams={props.teams} standings={props.standings} variant='teams-page' />
    </Box>
  );
}
